import script from "./BaseTableHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTableHeader.vue?vue&type=script&setup=true&lang=js"

import "./BaseTableHeader.vue?vue&type=style&index=0&id=04808cd6&lang=scss&scoped=true"
script.__scopeId = "data-v-04808cd6"

export default script